import { render, staticRenderFns } from "./sallCode.vue?vue&type=template&id=f746635c&scoped=true"
import script from "./sallCode.vue?vue&type=script&lang=js"
export * from "./sallCode.vue?vue&type=script&lang=js"
import style0 from "./sallCode.vue?vue&type=style&index=0&id=f746635c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f746635c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f746635c')) {
      api.createRecord('f746635c', component.options)
    } else {
      api.reload('f746635c', component.options)
    }
    module.hot.accept("./sallCode.vue?vue&type=template&id=f746635c&scoped=true", function () {
      api.rerender('f746635c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sall/sallCode.vue"
export default component.exports